<!--  -->
<template>
    <div ref="container" class="resume-dialog--container">
        <div class="resume-inner--container verify resume-form" :class="[innerClass]">
            <div class="resume-title">请验证手机号码</div>
            <div class="resume-form-item" :class="(formData.mobile && !_mobileRight) ?'is-error':'required'">
                <div class="resume-form-label">{{ ((formData.mobile && !_mobileRight) && '请输入11位手机号码') || '手机号' }}</div>
                <input v-model="formData.mobile" type="number" placeholder="请输入手机号" @input="handlerMobileInput" />
            </div>
            <div class="resume-form-item" :class="codeErrorTips ? 'is-error':'required'">
                <div class="resume-form-label">{{ codeErrorTips || '验证码' }}</div>
                <input v-model="formData.keyCode" type="number" placeholder="请输入验证码" @input="handlerCodeInput" />
                <div class="btn-getCode" :class="{ coding: codeTime }" @click="handlerGetCode">
                    <span v-if="codeTime">已发送{{ codeTime }}s</span>
                    <span v-else>获取验证码</span>
                </div>
            </div>
            <div class="resume-btn-group">
                <div @click="detain">取消</div>
                <div class="confirm" @click="confirm">确认</div>
            </div>
        </div>
        <dialog-detain ref="detain" @close="close" />
    </div>
</template>
<script>

import DialogDetain from '../components/Dialog/detain';
import CountDown from '../utils/countdown';
import { handlerDelivery } from '../js/delivery';

export default {
    components: { DialogDetain },
    data() {
        return {
            formData: {},
            innerClass: '',
            codeTime: 0,
            codeErrorTips: '',
            codeResponseId: 0
        };
    },
    computed: {
        _mobileRight() {
            return /1[3-9]\d{9}/.test(this.formData.mobile);
        }
    },
    mounted() {
        this.$root.cbProcess && this.$root.cbProcess({ action: 1002, type: 'new_resume_tel_verify' });
        this.$refs.container.addEventListener('touchmove', (e) => {
            e.preventDefault();
        }, false);
    },
    methods: {
        handlerCodeInput() {},
        handlerMobileInput() {
            this.clear();
            if (this.formData.mobile.length > 11) {
                this.formData.mobile = this.formData.mobile.slice(0, 11);
            }
        },
        async handlerGetCode() {
            if (this.codeTime || !this._mobileRight) {
                return;
            }
            CountDown.createTimer({
                remainTime: 59 * 1000,
                delay: 1000,
                label: 'code',
                timeoutFn: () => {
                    this.clear();
                },
                successFn: ({ ss }) => {
                    this.codeTime = `${ss}`;
                }
            });
            const res = await this.$api.getCheckCode({
                mobile: this.formData.mobile,
                platform: 1
            }).catch((e) => this.$handlerCapture(e));
            if (res?.isSuccess) {
                this.codeResponseId = res.entity?.responseid;
            }
        },
        confirm() {
            this.verifyCode();
            this.$root.cbProcess && this.$root.cbProcess({ action: 1003, type: 'new_resume_tel_verify_sure' });
        },
        async verifyCode() {
            this.codeErrorTips = '';
            if (this.formData.keyCode?.length !== 6) {
                this.codeErrorTips = '请输入6位验证码';
            } else {
                const res = await this.$api.verifyCode({
                    mobile: this.formData.mobile,
                    code: this.formData.keyCode,
                    responseid: this.codeResponseId,
                    operate: 'DELIVERY',
                    extend: JSON.stringify({
                        mobilestate: '1',
                        resumeid: this.$root.resumeId
                    })
                }).catch((e) => this.$handlerCapture(e));
                if (res.isSuccess) {
                    await handlerDelivery({ ...this.$root.$data, wbtk: '' }).catch((e) => this.$handlerCapture(e));
                    this.clear();
                } else {
                    this.codeErrorTips = '验证码输入错误';
                }
            }
        },
        detain() {
            this.$refs.detain.show();
            this.$root.cbProcess && this.$root.cbProcess({ action: 1003, type: 'new_resume_tel_verify_close' });
        },
        close() {
            this.innerClass = 'close';
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$root.complete && this.$root.complete({type: 'close' });
                    this.innerClass = '';
                    this.$nextTick(() => {
                        this.$root.visible = false;
                    });
                }, 400);
            });
        },
        clear() {
            this.formData.keyCode = '';
            CountDown.clearAssignTimer('code');
            this.codeErrorTips = '';
            this.codeTime = 0;
        }
    }
};
</script>
<style lang="scss" scoped>
.resume-dialog--container .resume-inner--container.verify{
    padding: 20px 16px;
    background: #fff;
    height: auto;
    border-radius: 10px 10px 0 0;
    .resume-title{
        font-size: 18px;
        margin-bottom: 10px;
        // text-align: center;
    }
}
</style>
